
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.md?watch=parent';
    export const demoIndex = {
  ids: ["column-demo-common","column-demo-markdown","column-demo-group","column-demo-stack"],
  getter: () => import(/* webpackChunkName: "meta__Column" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Column/index.md?type=demo')
};